/**
 * Careers Page Scripts
 *
 * @package Ultra_Maritime
 */

'use strict';

document.addEventListener( 'DOMContentLoaded', function() {

	// Hero: Video Background.
	const heroVideo = document.querySelector( '.careers-hero__video' );

	if ( heroVideo ) {

		function markVideoReady() {
			heroVideo.classList.add( 'is-ready' );
		}

		// Fade in video once enough data is buffered to play smoothly.
		const listenerOptions = {once: true};
		heroVideo.addEventListener( 'canplaythrough', markVideoReady, listenerOptions );

		// Handle already-cached video (readyState 3 = HAVE_FUTURE_DATA, 4 = HAVE_ENOUGH_DATA).
		if ( 3 <= heroVideo.readyState ) {
			markVideoReady();
		}

		// Trigger play — catches Safari which sometimes needs an explicit call.
		heroVideo.play().catch( function() {
			// Autoplay blocked — poster image remains visible as fallback.
		});

	}

});